/* ============================================================
   Cloudbase.pk — Main JS
   Pill nav: burger, drawer, dropdowns, FAQ, scroll animations
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ─────────────────────────────────────────
     NAV — Burger + Drawer
     ───────────────────────────────────────── */
  const burger  = document.getElementById('nav-burger');
  const drawer  = document.getElementById('nav-drawer');
  const header  = document.getElementById('site-header');

  function openDrawer() {
    drawer.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger && drawer) {
    burger.addEventListener('click', () => {
      drawer.classList.contains('open') ? closeDrawer() : openDrawer();
    });

    // Click outside drawer-inner closes it
    drawer.addEventListener('click', (e) => {
      if (!e.target.closest('.nav-drawer-inner')) closeDrawer();
    });

    // Close on drawer link click
    drawer.querySelectorAll('.drawer-link, .drawer-btn').forEach(el => {
      el.addEventListener('click', closeDrawer);
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // Close drawer when resizing to desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth > 860) closeDrawer();
  }, { passive: true });

  /* ─────────────────────────────────────────
     NAV — Dropdown (desktop hover + keyboard)
     ───────────────────────────────────────── */
  document.querySelectorAll('.nav-dropdown-wrap').forEach(wrap => {
    const btn      = wrap.querySelector('.nav-link--drop');
    const dropdown = wrap.querySelector('.nav-dropdown');
    if (!btn || !dropdown) return;

    // Click: toggle dropdown (especially for touch devices and desktop clicks)
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = wrap.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
      
      // Close other open dropdowns
      document.querySelectorAll('.nav-dropdown-wrap').forEach(other => {
        if (other !== wrap) {
          other.classList.remove('open');
          const otherBtn = other.querySelector('.nav-link--drop');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Keyboard: Enter/Space to open; Escape to close
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isOpen = wrap.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(isOpen));
      }
      if (e.key === 'Escape') {
        wrap.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });

    // Click outside closes
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) {
        wrap.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ─────────────────────────────────────────
     STICKY HEADER — scrolled class
     ───────────────────────────────────────── */
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* ─────────────────────────────────────────
     ACTIVE NAV LINK on scroll (IntersectionObserver)
     ───────────────────────────────────────── */
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-link[href^="#"]');

  if (sections.length && navLinks.length) {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          navLinks.forEach(link => {
            link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
          });
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });

    sections.forEach(sec => sectionObserver.observe(sec));
  }

  /* ─────────────────────────────────────────
     FAQ ACCORDION
     ───────────────────────────────────────── */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item   = trigger.closest('.acc-item') || trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.acc-item, .accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ─────────────────────────────────────────
     SCROLL ANIMATIONS
     ───────────────────────────────────────── */
  const heroEls = document.querySelectorAll('[hero-animation]');
  const scrollEls = [
    ...document.querySelectorAll('[slide-animation]'),
    ...document.querySelectorAll('[card-animation]'),
    ...document.querySelectorAll('[finsaro-card]'),
  ];

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    /* GSAP path */
    gsap.registerPlugin(ScrollTrigger);

    if (heroEls.length) {
      gsap.fromTo(heroEls,
        { opacity: 0, y: 32 },
        { opacity: 1, y: 0, duration: 0.9, stagger: 0.13, ease: 'power3.out', delay: 0.2 }
      );
    }

    document.querySelectorAll('[slide-animation]').forEach(el => {
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } }
      );
    });

    document.querySelectorAll('[card-animation], [finsaro-card]').forEach(el => {
      const siblings = [...(el.parentElement?.children || [])];
      const idx      = siblings.indexOf(el);
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        { opacity: 1, y: 0, duration: 0.75, delay: (idx % 4) * 0.1, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } }
      );
    });

  } else {
    /* IntersectionObserver fallback */
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el   = entry.target;
        const sibs = [...(el.parentElement?.children || [])];
        const idx  = sibs.indexOf(el);
        const delay = (el.hasAttribute('card-animation') || el.hasAttribute('finsaro-card'))
          ? (idx % 4) * 100 : 0;
        setTimeout(() => el.classList.add('animate-in'), delay);
        observer.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    heroEls.forEach(el => setTimeout(() => el.classList.add('animate-in'), 150));
    scrollEls.forEach(el => io.observe(el));
  }

  /* ─────────────────────────────────────────
     LENIS SMOOTH SCROLL
     ───────────────────────────────────────── */
  if (typeof Lenis !== 'undefined') {
    const lenis = new Lenis({
      duration: 1.1,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    if (typeof ScrollTrigger !== 'undefined') {
      lenis.on('scroll', ScrollTrigger.update);
    }

    // Close drawer on smooth-scroll anchor click
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', () => setTimeout(closeDrawer, 100));
    });
  }

  /* ─────────────────────────────────────────
     3D INTERACTION ENGINE IMPLEMENTATION
     ───────────────────────────────────────── */

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. CURSOR CONTACT & 3D TILT ENGINE */
  function init3DTiltEngine() {
    if (isTouchDevice || prefersReducedMotion) return;

    const tiltEls = document.querySelectorAll('[data-3d-tilt]');

    tiltEls.forEach(el => {
      // Create glare overlay if requested
      if (el.hasAttribute('data-glare') && !el.querySelector('.glare-overlay')) {
        const glare = document.createElement('div');
        glare.className = 'glare-overlay';
        el.appendChild(glare);
      }

      let reqId = null;
      let targetRotateX = 0, targetRotateY = 0;
      let currentRotateX = 0, currentRotateY = 0;
      let targetTransX = 0, targetTransY = 0;

      const maxTilt = parseFloat(el.getAttribute('data-tilt-max')) || 12;
      const perspective = el.getAttribute('data-tilt-perspective') || '1000px';
      el.style.perspective = perspective;

      const updateTransform = () => {
        // Lerp rotation for buttery smooth motion
        currentRotateX += (targetRotateX - currentRotateX) * 0.15;
        currentRotateY += (targetRotateY - currentRotateY) * 0.15;

        el.style.transform = `perspective(${perspective}) rotateX(${currentRotateX.toFixed(2)}deg) rotateY(${currentRotateY.toFixed(2)}deg) translateZ(10px)`;

        // Parallax translate inner depth layers if present
        const layers = el.querySelectorAll('.layer-depth-1, .layer-depth-2, .layer-depth-3, .layer-depth-4, .float-card, .bc-emoji');
        layers.forEach(layer => {
          const depth = parseFloat(layer.getAttribute('data-depth')) || (layer.classList.contains('layer-depth-3') ? 35 : (layer.classList.contains('float-card') ? 45 : 20));
          const layerX = (targetRotateY / maxTilt) * depth;
          const layerY = -(targetRotateX / maxTilt) * depth;
          layer.style.transform = `translate3d(${layerX.toFixed(2)}px, ${layerY.toFixed(2)}px, ${depth}px)`;
        });

        if (Math.abs(targetRotateX - currentRotateX) > 0.01 || Math.abs(targetRotateY - currentRotateY) > 0.01) {
          reqId = requestAnimationFrame(updateTransform);
        } else {
          reqId = null;
        }
      };

      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;

        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const pctX = (mouseX / width) - 0.5;
        const pctY = (mouseY / height) - 0.5;

        targetRotateX = -pctY * maxTilt * 2;
        targetRotateY = pctX * maxTilt * 2;

        // Glare movement
        const glare = el.querySelector('.glare-overlay');
        if (glare) {
          glare.style.background = `radial-gradient(circle at ${(mouseX / width * 100).toFixed(1)}% ${(mouseY / height * 100).toFixed(1)}%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 70%)`;
        }

        if (!reqId) reqId = requestAnimationFrame(updateTransform);
      });

      el.addEventListener('mouseleave', () => {
        targetRotateX = 0;
        targetRotateY = 0;

        if (!reqId) reqId = requestAnimationFrame(updateTransform);

        const glare = el.querySelector('.glare-overlay');
        if (glare) {
          glare.style.opacity = '0';
        }
      });

      el.addEventListener('mouseenter', () => {
        const glare = el.querySelector('.glare-overlay');
        if (glare) {
          glare.style.opacity = '1';
        }
      });
    });
  }

  /* 2. MAGNETIC BUTTON CONTROLLER */
  function initMagneticEngine() {
    if (isTouchDevice || prefersReducedMotion) return;

    const magEls = document.querySelectorAll('[data-magnetic], .btn-primary-lg, .btn-ghost-lg, .nav-cta');

    magEls.forEach(btn => {
      let reqId = null;
      let targetX = 0, targetY = 0;
      let currentX = 0, currentY = 0;

      const updateMag = () => {
        currentX += (targetX - currentX) * 0.2;
        currentY += (targetY - currentY) * 0.2;

        btn.style.transform = `translate3d(${currentX.toFixed(2)}px, ${currentY.toFixed(2)}px, 15px)`;

        if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
          reqId = requestAnimationFrame(updateMag);
        } else {
          reqId = null;
        }
      };

      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const distanceX = e.clientX - centerX;
        const distanceY = e.clientY - centerY;

        targetX = distanceX * 0.3;
        targetY = distanceY * 0.3;

        if (!reqId) reqId = requestAnimationFrame(updateMag);
      });

      btn.addEventListener('mouseleave', () => {
        targetX = 0;
        targetY = 0;
        if (!reqId) reqId = requestAnimationFrame(updateMag);
      });
    });
  }

  /* 3. TACTILE 3D CLICK REACTION SYSTEM */
  function init3DClickEngine() {
    const clickTargets = document.querySelectorAll('[data-3d-click], .btn-primary-lg, .btn-ghost-lg, .nav-cta, .pricing-btn, .why-card, .bento-cell, .stat-box, .pricing-card');

    clickTargets.forEach(target => {
      target.style.cursor = 'pointer';

      target.addEventListener('mousedown', (e) => {
        target.classList.add('is-3d-pressed');

        // Create 3D Shockwave ripple
        const rect = target.getBoundingClientRect();
        const wave = document.createElement('div');
        wave.className = 'shockwave-3d';

        const size = Math.max(rect.width, rect.height) * 0.8;
        wave.style.width = `${size}px`;
        wave.style.height = `${size}px`;

        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;

        wave.style.left = `${x}px`;
        wave.style.top = `${y}px`;

        // Clean previous waves
        target.querySelectorAll('.shockwave-3d').forEach(w => w.remove());
        target.appendChild(wave);

        setTimeout(() => wave.remove(), 600);
      });

      const releasePress = () => target.classList.remove('is-3d-pressed');
      target.addEventListener('mouseup', releasePress);
      target.addEventListener('mouseleave', releasePress);
      target.addEventListener('touchend', releasePress);
    });
  }

  /* 4. 3D SCROLL PERSPECTIVE ENGINE */
  function init3DScrollPerspective() {
    if (prefersReducedMotion) return;

    const heroMesh = document.querySelector('.hero-bg-mesh');
    const heroVisual = document.querySelector('.hero-visual .browser-frame');
    const floatCards = document.querySelectorAll('.hero-visual .float-card');

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      // 3D Hero Scroll Perspective Transform
      if (heroVisual) {
        gsap.to(heroVisual, {
          rotateX: 14,
          scale: 0.94,
          translateZ: -80,
          opacity: 0.85,
          ease: 'none',
          scrollTrigger: {
            trigger: '.hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 0.6
          }
        });
      }

      // Parallax Float Cards in Hero
      floatCards.forEach((fc, i) => {
        gsap.to(fc, {
          y: (i === 0 ? -60 : 60),
          rotateZ: (i === 0 ? -6 : 8),
          ease: 'none',
          scrollTrigger: {
            trigger: '.hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 0.4
          }
        });
      });

      // Ambient 3D Mesh Parallax Movement
      if (heroMesh) {
        gsap.to(heroMesh, {
          y: 120,
          rotateX: 20,
          ease: 'none',
          scrollTrigger: {
            trigger: '.hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 1
          }
        });
      }

      // 3D Cascade Tilt on Cards upon Scroll Entry
      document.querySelectorAll('.why-card, .bento-cell, .stat-box, .pricing-card').forEach(card => {
        gsap.fromTo(card, 
          { rotateX: 15, rotateY: -8, translateZ: -40 },
          { 
            rotateX: 0, 
            rotateY: 0, 
            translateZ: 0, 
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 90%',
              toggleActions: 'play none none none'
            }
          }
        );
      });
    } else {
      // Native rAF Scroll Fallback
      window.addEventListener('scroll', () => {
        const scrolled = window.scrollY;
        if (heroMesh) {
          heroMesh.style.transform = `translate3d(0, ${scrolled * 0.2}px, -50px)`;
        }
        if (heroVisual && scrolled < 800) {
          heroVisual.style.transform = `perspective(1000px) rotateX(${(scrolled * 0.015).toFixed(2)}deg) translateZ(-${(scrolled * 0.1).toFixed(0)}px)`;
        }
      }, { passive: true });
    }
  }

  /* 5. INTERACTIVE MINI POS REGISTER IN BENTO GRID */
  function initBentoMiniPOSInteractivity() {
    const posRows = document.querySelectorAll('.mpos-row');
    const posTotal = document.querySelector('.mpos-total span:last-child');

    if (!posRows.length || !posTotal) return;

    let items = [
      { name: 'Samsung TV', price: 120000, qty: 1 },
      { name: 'iPhone Case', price: 800, qty: 3 },
      { name: 'USB Keyboard', price: 3500, qty: 1 }
    ];

    posRows.forEach((row, idx) => {
      row.addEventListener('click', () => {
        items[idx].qty += 1;

        // Animate row bump
        gsap ? gsap.fromTo(row, { scale: 0.95, translateZ: 25 }, { scale: 1, translateZ: 0, duration: 0.3 }) : null;

        // Update item display
        const priceSpan = row.querySelector('span:last-child');
        if (priceSpan) {
          const itemTotal = items[idx].price * items[idx].qty;
          priceSpan.textContent = `Rs. ${itemTotal.toLocaleString()}`;
        }

        // Calculate and update grand total
        const grandTotal = items.reduce((sum, item) => sum + (item.price * item.qty), 0);
        posTotal.textContent = `Rs. ${grandTotal.toLocaleString()}`;

        // Total badge flash effect
        posTotal.style.transition = 'color 0.2s, transform 0.2s';
        posTotal.style.color = '#16a34a';
        posTotal.style.transform = 'scale(1.1)';
        setTimeout(() => {
          posTotal.style.color = '';
          posTotal.style.transform = 'none';
        }, 300);
      });
    });
  }

  // Initialize all 3D interaction systems
  init3DTiltEngine();
  initMagneticEngine();
  init3DClickEngine();
  init3DScrollPerspective();
  initBentoMiniPOSInteractivity();
});

